<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h6 class="mb-0">Slides</h6>
      <span class="fs-12 text-muted">{{ slides.length }} slide{{ slides.length === 1 ? "" : "s" }}</span>
    </div>
    <div v-if="loading" class="py-4 text-center">
      <wtr-loader variant="primary" addText></wtr-loader>
    </div>
    <draggable
      v-else-if="localSlides.length"
      v-model="localSlides"
      class="presentation-slide-grid"
      :disabled="disabled"
      @end="handleDragEnd"
    >
      <div
        v-for="(slide, index) in localSlides"
        :key="slide.id"
        class="presentation-slide-tile"
      >
        <wtr-img
          :src="slide.thumbnailPath || slide.path"
          :resourceId="slide.resourceId"
          :containerName="slide.containerName"
          :altImage="$icons.NO_THUMBNAIL_FOUND"
          imgClass="presentation-slide-image"
          disableLazy
        ></wtr-img>
         <div
          class="presentation-slide-name"
          :title="getDisplaySlideName(index)"
        >
          {{ getDisplaySlideName(index) }}
        </div>
      </div>
    </draggable>
    <div v-else class="text-muted fs-13 py-4 text-center">
      No slides uploaded
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "presentation-slide-grid",
  components: {
    draggable,
  },
  props: {
    slides: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localSlides: [],
    };
  },
  watch: {
    slides: {
      immediate: true,
      handler(slides) {
        this.localSlides = slides ? slides.slice() : [];
      },
    },
  },
  methods: {
    getDisplaySlideName(index) {
      return `Slide_${index + 1}.jpg`;
    },
    handleDragEnd(event) {
      if (!event || event.oldIndex === event.newIndex) return;
      this.$emit("reorder", this.localSlides.slice());
    },
  },
};
</script>

<style scoped lang="scss">
.presentation-slide-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 12px;
}

.presentation-slide-tile {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  cursor: grab;
}

.presentation-slide-tile:active {
  cursor: grabbing;
}

.sortable-ghost {
  opacity: 0.5;
}

.presentation-slide-tile ::v-deep .presentation-slide-image {
  display: block;
  width: 100%;
  aspect-ratio: 4 / 3;
  object-fit: contain;
  background: #f8f9fa;
}

.presentation-slide-name {
  padding: 6px 8px;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
